<template>
  <div>
    <AwsSku :disabled="disabled" :amzSkuCode="amzSkuCode" :isCopy="isCopy" />
  </div>
</template>
<script>
import AwsSku from '../components/aws-sku'
export default {
  name: 'ecom-base-awsGoods-detail',
  components: { AwsSku },
  data() {
    return { activeName: 'skuBase', amzSkuStatus: '' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    isCopy() {
      return this.pageType === 'copy'
    },
    amzSkuCode() {
      return this.params.amzSkuCode
    },
  },
}
</script>
